import { css } from 'styled-components'

export const flexCol = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

export const flexRow = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const hideScrollBar = css`
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`
